import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/base/SectionTitle';
import { relatedItems } from '@/mocks/drama';

export default function RelatedSection() {
  return (
    <section id="related" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <Reveal>
          <SectionTitle
            eyebrow="相关推荐"
            title="看完意犹未尽？这些题材可以接着看"
            description="以下几部围绕家庭、都市生活与旧日恩怨展开的短剧，与《漂亮的小姨子》在情绪配方和叙事节奏上比较接近，适合顺势追下去。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 md:gap-6 grid-cols-2 lg:grid-cols-4">
          {relatedItems.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group h-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <div className="h-56 md:h-64 w-full overflow-hidden">
                  <img
                    src={item.poster}
                    alt={`短剧《${item.title}》海报复刻画面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center justify-between gap-2">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs text-secondary-800">{item.genre}</span>
                    <span className="font-label text-xs text-foreground-500 whitespace-nowrap">{item.episodes}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 font-body text-xs md:text-sm leading-relaxed text-foreground-700">{item.blurb}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}